import { useEffect, useState } from "react";
import { ErrorContext } from "../../utils/context/error";
import { getAreasAll, setBloqueaArea } from "../../services/areas";
import Icon from "../../Icons/general/Icon";
import IconM from "../dashboard/menu/icons/Icon";
import AreaModal from "./areamodal";
import useTable from "../../hooks/table";
import TableFooter from "../../hooks/table/footer";

function AreaView() {
  const [Area, setArea] = useState([]);
  const { setShowToast, setOpciones } = ErrorContext();
  const [AreaId, setAreaId] = useState(0);
  const [showM, setShowM] = useState(false);
  const [tag, setTag] = useState(0);
  const [estado, setEstado] = useState("AC");
  const [selectedRow, setSelectedRow] = useState(null);
  const [page, setPage] = useState(1);
  const { slice, range } = useTable(Area, page, 10);  
  
 //--------- Metodo para mostrar las areas en la grilla
  const fillAreas = async () => 
    {
      setShowToast(false);
      const response = await getAreasAll();
      if (response) 
        {
           if (response.status === 200) 
            {
               setArea(response.data.data);
            } 
           else 
            {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
            }
        }
    };

  //----- boton crear-Editar-Eliminar Area
  const handleCrearArea = (tagId) => 
    {
      if (tagId === 0) setAreaId(0);
      setShowM(true);
      setTag(tagId);
    };

  //----- Bloquea- Desbloquea
  const handleBloqueaArea = async (tagId) => 
    {
     setShowToast(false);
     const response = await setBloqueaArea(AreaId, tagId);
     if (response) 
      {
         if (response.status === 200) 
          {
             setTag(0);
             setEstado(response.data.data[0].Estado);
             setAreaId(response.data.data[0].AreaId);
             fillAreas();
          } 
         else 
         {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);
         }
      }
    };
  
  //------ al dar click en la fila
  const handlefilas = (Item, index) => 
    {
      setSelectedRow(index);
      setAreaId(Item.AreaId);
      setEstado(Item.Estado);
    };

  //-------- Llamada al iniciar
  useEffect(() => 
    {
      setShowM(false);
      fillAreas();
    }, []);
  return (
    <>
      <div className="">
        <div className="paneltitle">
          <label className="text-[1.0rem] font-light text-gray-400 leading-none"> Administración/Digiturno/Areas</label>
        </div>
        <div className="panelmenu">
            <button className="btnmenu" onClick={() => handleCrearArea(0)} >
              <IconM svg="newfile" className="iconmenu" title="newfile" />
              <span>Nuevo</span>
            </button>
            
            <button className="btnmenu" id="Editar" disabled={selectedRow === null} onClick={() => handleCrearArea(1)}>
              <IconM svg="pencil" className="iconmenu" title="pencil" />
              <span>Editar</span>
            </button>
       
            <button className="btnmenu" id="Eliminar" onClick={() => handleCrearArea(2)} disabled={selectedRow === null}>
              <IconM svg="delfile" className="iconmenu" title="delfile" />
              <span>Eliminar</span>
            </button>

            {estado === "AC" ? 
            (
               <button className="btnmenu" id="Bloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaArea(0)}>
                   <IconM svg="lock" className="iconmenu" title="lock" />
                   <span>Bloquear</span>
                </button>
            ) : 
            (
              <button className="btnmenu" id="Desbloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaArea(1)}>
                 <IconM svg="dlock" className="iconmenu" title="dlock"/>
                 <span>Desbloquear</span>
              </button>
            )}
        </div>
      </div>  
      <div className="mt-2 rounded-lg border border-stone-200 overflow-x-auto">
         <table className="w-full table-auto min-w-[700px]">
            <thead className="border-b border-stone-200 text-sm font-medium ">
               <tr>
                   <th className="hidden md:table-cell px-2.5 py-2 text-start font-medium">Id.</th>
                   <th className="px-2.5 py-2 text-start font-medium">Nombre</th>
                   <th className="px-2.5 py-2 text-start font-medium">Página</th>
                   <th className="px-2.5 py-2 text-start font-medium">
                      <span className="block lg:hidden">Disp.</span>
                      <span className="hidden lg:block">Dispensador</span>
                    </th>
                   <th className="px-2.5 py-2 text-start font-medium">Mensaje Inf.</th>
                   <th className="px-2.5 py-2 text-start font-medium">Solicita Paciente</th>
                   <th className="px-2.5 py-2 text-start font-medium">Codigo Qr</th>
                   <th className="px-2.5 py-2 text-start font-medium">Estado</th>
               </tr>
            </thead>
            <tbody className="group text-sm text-stone-800 ">
               {slice.map((item, index) => {
                  return (
                    <tr className={`border-b border-stone-200 last:border-0 ${selectedRow === index ? 'bg-blue-50 selected cursor-pointer' : ''}`} key={index} id={`fila${item.ConsultID}`} onClick={() => handlefilas(item, index)}>
                       <td className="hidden md:table-cell">{item.AreaId}</td>
                       <td>{item.NombreArea}</td>
                       <td>{item.Pagina}</td>
                       <td>{item.Dispensa === "A" ? "Automatico" : item.Dispensa === "M" ? "Manual" : ""}</td>
                       <td>{item.MensajeInf === "SI" ? (<Icon svg="checkSquare" className="w-[1.2rem] h-[1.2rem]" title="checklg"/>):("")}</td>
                       <td className="center">{item.Benefic === "SI" ? (<Icon svg="checkSquare" className="w-[1.2rem] h-[1.2rem]" title="checklg"/>):("")}</td>
                       <td className="center">{item.CodigoQr === "SI" ? (<Icon svg="checkSquare" className="w-[1.2rem] h-[1.2rem]" title="checklg"/>):("")}</td>
                       <td className="item-center">
                          {item.Estado === "AC" ? (<span className="tagac">Activo</span>) : (<span className="tagan">Suspendido</span>)}
                       </td>
                    </tr>
                  )})}
            </tbody>
         </table>
      </div>
      <TableFooter range={range} slice={slice} setPage={setPage} page={page} /> 
      <AreaModal
        show={showM}
        AreaI={AreaId}
        Tag={tag}
        handleshow={setShowM}
        fillAreas={fillAreas}
      ></AreaModal>
    </>
  );
}
export default AreaView;
